import * as utils from '@/components/partials/jobs/JobsInquiryForm/utils/common';
import * as csmUtils from '@/components/partials/jobs/JobsInquiryForm/utils/csmRoleUtils';
import type {
  JobsSectionField,
  JobsSectionModels,
} from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

export default ({ inquiry }: JobsSectionModels): JobsSectionField[] => {
  return [
    {
      attrs: {
        label: 'Sales cycle',
        value: utils.getSalesCycleFieldValue(inquiry),
        isHidden: !csmUtils.hasRenewalsOrUpselsInQuotaMeasuring({
          csmQuotaTypeMain: inquiry.csmQuotaTypeMain,
          csmQuotaMetricMain: inquiry.csmQuotaMetricMain,
        }),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) => utils.isSingleFieldFilled(inquiry.salesCycleLength),
    },
    {
      attrs: {
        label: 'Quota structure',
        value: csmUtils.getQuotaStructureFieldValue(inquiry),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) =>
        utils.isSingleFieldFilled(inquiry.csmQuotaTypeMain) || utils.isSingleFieldFilled(inquiry.csmQuotaTypeOther),
    },
    {
      attrs: {
        label: 'Quota system',
        value: csmUtils.getQuotaSystemValue(inquiry),
        isHidden: csmUtils.getIsQoutaFliedsHidden(inquiry),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) =>
        utils.isMultiselectFieldHasSelectedOptionOrOtherOptionFilled(
          inquiry.csmQuotaMetricMain,
          inquiry.csmQuotaMetricOther,
        ),
    },
    {
      attrs: {
        label: 'Quota period',
        value: csmUtils.getQuotaPeriodFieldValue(inquiry),
        isHidden: csmUtils.getIsQoutaFliedsHidden(inquiry),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) =>
        utils.isSingleFieldFilled(inquiry.csmQuotaPeriodMain) || utils.isSingleFieldFilled(inquiry.csmQuotaPeriodOther),
    },
    {
      attrs: {
        label: 'Quota attainment last period',
        value: csmUtils.getLastPeriodQuotaAttainment(inquiry),
        attributeName: 'quotaAttainmentPerPeriod',
        isHidden:
          csmUtils.getIsQoutaFliedsHidden(inquiry) || csmUtils.getIsQoutaAttainmentLastYearFieldIsHidden(inquiry),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) => utils.isSingleFieldFilled(inquiry.quotaAttainmentPerPeriod),
    },
    {
      attrs: {
        label: 'Quota attainment last year',
        value: csmUtils.getLastYearQuotaAttainment(inquiry),
        attributeName: 'quotaAttainmentPerLastYear',
        isHidden: csmUtils.getIsQoutaFliedsHidden(inquiry),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) => utils.isSingleFieldFilled(inquiry.quotaAttainmentPerLastYear),
    },

    {
      attrs: {
        label: 'Average renewals contract value',
        value: csmUtils.getAverageRenewalsFieldValue(inquiry),
        isHidden: !csmUtils.hasRenewalsInQuotaMeasuring(inquiry.csmQuotaMetricMain),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) => utils.isSingleFieldFilled(inquiry.csmRenewalValue),
    },

    {
      attrs: {
        label: 'Average up-sell contract value',
        value: csmUtils.getAverageUpsellsFieldValue(inquiry),
        isHidden: !csmUtils.hasUpselsInQuotaMeasuring({
          csmQuotaTypeMain: inquiry.csmQuotaTypeMain,
          csmQuotaMetricMain: inquiry.csmQuotaMetricMain,
        }),
      },
      component: 'PortfolioJobsInquirySectionField',
      getIsFulfilled: ({ inquiry }) => utils.isSingleFieldFilled(inquiry.csmUpsellValue),
    },
  ];
};
